import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { demoTrue } from "./demoTrueAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    UsedQuestionsId:[],
    Attributes: [],
    LastCard: false,
}

export const demoTrueAsync = createAsyncThunk(
    "/demotrue",
    async ({gender, player},{getState, rejectWithValue }) => {
        try {
            const state = getState();
            const usedid = state.demoTrue.UsedQuestionsId
            const sessionid = state.gameStatus.sessions['demo'].sessionId


            const response = await demoTrue(gender, player, usedid, sessionid);
            return response
        } catch (error) {
            console.error("Error in demoTrueAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const demoTrueSlice = createSlice({
    name: "demotrue",
    initialState,
    reducers: {
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.Attributes = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(demoTrueAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(demoTrueAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;

            })}})

export const selectDemoTrue = (state) => state.demoTrue
export const {resetState} = demoTrueSlice.actions;

export default demoTrueSlice.reducer